var map = {
	"./Ambulance.png": 1375,
	"./Ask A Doctor.png": 1376,
	"./Blood Cells.png": 1377,
	"./Brain.png": 1378,
	"./Dental.png": 1379,
	"./Depression.png": 1380,
	"./Diagnostics.png": 1381,
	"./Disabled.png": 1382,
	"./Doctor.png": 880,
	"./Ear.png": 1383,
	"./Hospital.png": 1384,
	"./Injection.png": 1385,
	"./Medical Book.png": 1386,
	"./Medical Folder.png": 1387,
	"./Mouth.png": 1388,
	"./Online Claim.png": 1389,
	"./Online Pharmacy.png": 1390,
	"./Optometry.png": 1391,
	"./Pill Bottle.png": 1392,
	"./Podiatry.png": 1393,
	"./Price Tag.png": 1394,
	"./Radiation Theraphy.png": 1395,
	"./Savings.png": 1396,
	"./Symptom List.png": 1397
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1374;